
import React from 'react';

const PropertyDetails = ({ selectedProperty, handleCloseModal }) => {
  if (!selectedProperty) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 9999 }}>
        <div className="modal-dialog modal-lg" style={{ maxWidth: '900px' }}>
          <div className="modal-content">

            {/* HEADER – SAME AS RULE DETAILS */}
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Property Details</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={handleCloseModal}
              />
            </div>

            {/* BODY – UNCHANGED */}
            <div className="modal-body">
              <div className="row">

                {/* LEFT COLUMN */}
                <div className="col-md-6">
                  <p className="border-bottom"><strong>Property Name:</strong> {selectedProperty.property_name}</p>
                  <p className="border-bottom"><strong>Province:</strong> {selectedProperty.province?.name || '-'}</p>
                  <p className="border-bottom"><strong>Street Number:</strong> {selectedProperty.street_number || '-'}</p>
                  <p className="border-bottom"><strong>Street Name:</strong> {selectedProperty.street_name || '-'}</p>
                  <p className="border-bottom"><strong>City:</strong> {selectedProperty.city || '-'}</p>
                  <p className="border-bottom"><strong>Postal Code:</strong> {selectedProperty.postal_code || '-'}</p>
                  {/* <p><strong>Unit:</strong> {selectedProperty.unit || '-'}</p>
                  <p><strong>Rooms:</strong> {selectedProperty.rooms || '-'}</p> */}
                  <p className="border-bottom"><strong>Total Units:</strong> {selectedProperty.units?.length || 0}</p>

                </div>

                {/* RIGHT COLUMN */}
                <div className="col-md-6">
                  {/* <p><strong>Filled Rooms:</strong> {selectedProperty.filled_rooms || 0}</p>
                  <p>
                    <strong>Is Condominium:</strong>{' '}
                    {selectedProperty.is_condominium ? 'Yes' : 'No'}
                  </p>

                  <hr /> */}

               
                  <p ><strong>Units:</strong></p>

                  {selectedProperty.units?.length
                    ? selectedProperty.units.map((unit, index) => (
                      <p key={unit.id} >
                        {index + 1}. {unit.unit} - {unit.unit_type} - {unit.unit_status}
                      </p>
                    ))
                    : <p>No Units Available</p>}
                    <hr />

   <p>
                    <strong>Landlord:</strong>{' '}
                    {selectedProperty.landlord
                      ? `${selectedProperty.landlord.first_name} ${selectedProperty.landlord.last_name}`
                      : '-'}
                  </p>

                  <p><strong>Landlord Email:</strong> {selectedProperty.landlord?.email || '-'}</p>
                  <p><strong>Landlord Mobile:</strong> {selectedProperty.landlord?.mobile_no || '-'}</p>

                  <hr />

                  <p>
                    <strong>Tenants:</strong>{' '}
                    {selectedProperty.tenants?.length
                      // ? selectedProperty.tenants.map(t => t.full_name).join(', ')
                      ? selectedProperty.tenants
                        .map(t => `${t.tenant?.first_name || ''} ${t.tenant?.last_name || ''}`)
                        .join(', ')

                      : '-'}
                  </p>
                  <hr />
                </div>

              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleCloseModal}>
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* BACKDROP */}
      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default PropertyDetails;
